import type { ReactNode } from 'react';
import styles from './Nav.module.css';

export type NavProps = {
  /** Start column (e.g. primary nav / dock). */
  brand: ReactNode;
  /** Optional centered group — omit when nav lives only in `brand`. */
  children?: ReactNode;
  end?: ReactNode;
};

/** Horizontal nav: start + optional centered links + optional end. Use react-router `Link` inside children. */
export function Nav({ brand, children, end }: NavProps) {
  return (
    <nav className={styles.nav} aria-label="Principal">
      <div className={styles.start}>{brand}</div>
      {children ? <div className={styles.center}>{children}</div> : null}
      {end ? <div className={styles.end}>{end}</div> : <div className={styles.end} aria-hidden />}
    </nav>
  );
}
